"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrecisionPatternHourPG = exports.PrecisionPattern = exports.Precision = void 0;
var Precision;
(function (Precision) {
    Precision["hour"] = "hour";
    Precision["day"] = "day";
    Precision["month"] = "month";
})(Precision || (exports.Precision = Precision = {}));
var PrecisionPattern;
(function (PrecisionPattern) {
    PrecisionPattern["hour"] = "yyyy-MM-ddTHH:00:00.000Z";
    PrecisionPattern["day"] = "yyyy-MM-ddT00:00:00.000Z";
    PrecisionPattern["month"] = "yyyy-MM-01T00:00:00.000Z";
})(PrecisionPattern || (exports.PrecisionPattern = PrecisionPattern = {}));
exports.PrecisionPatternHourPG = `yyyy-MM-dd"T"HH24:00:00.000Z`;
//# sourceMappingURL=search.js.map